import { api } from "./client";

export const ConnectorsAPI = {
  list: () => api.get("/connectors"),
  create: (payload) => api.post("/connectors", payload),
  update: (id, payload) => api.patch(`/connectors/${id}`, payload),
  remove: (id) => api.delete(`/connectors/${id}`),
  test: (id, payload = {}) => api.post(`/connectors/${id}/test`, payload),
};
